export const SITE_APP_TITLE = 'ResiDesk'

export const SITE_SEO_TITLE =
  'ResiDesk | The AI operations and intelligence platform for multifamily'

export const SITE_DESCRIPTION =
  'Build trusted resident relationships that open a window into what\u2019s really happening across your portfolio.'

export const SITE_CANONICAL_URL = 'https://hello.theresidesk.com/'

export const SITE_OG_TYPE = 'website'

export const SITE_TWITTER_CARD = 'summary_large_image'

export const SITE_ROBOTS = 'noindex, nofollow, noarchive'

export const SITE_GOOGLE_TAG_MANAGER_ID = 'GTM-MMBCV843'
